import qs from 'qs';
import axios from 'axios';
import Layer from '@/utils/Layer/index';
const Cookie = require('js-cookie');
import { ENV_CONFIG } from '@/config';

const DEF_DOMAIM = `//${ENV_CONFIG.CUSTOMER_API_DOMAIN}` + (window.location.protocol.split(':')[0] === 'https' ? ENV_CONFIG.HTTPS_PORT : ENV_CONFIG.HTTP_PORT)

const service = axios.create({
  timeout: 1000 * 10,
  withCredentials: false,
  baseURL: `${DEF_DOMAIM}/v1`,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Ca-Stage': ENV_CONFIG.X_CA_STAGE
  }
});
// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['token'] = Cookie.get('token') || '';
    config.metadata = { startTime: new Date() };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response拦截器
service.interceptors.response.use(
  res => {
    const { status, data } = res;
    if (status === 200) {
      const { code, errorCode, errorMessage } = data;
      if ((code !== 200 || errorCode !== 0) && code !== 0) {
        if (errorMessage) {
          Layer.msg(errorMessage);
        }
      }
      return Promise.resolve(data);
    } else {
      return Promise.reject(res);
    }
  },
  err => {
    return {
      code: 500,
      errorCode: 500,
      errorMessage: `网络错误-${err}`
    };
  }
);

const get = (url, params, config = {}) => {
  let default_config = {
    method: 'get',
    url: url,
    params: params,
    ...config
  };
  return service(default_config);
};
const post = (url, data, config = {}) => {
  const contentType = config.headers ? (config.headers['Content-Type'] || 'application/x-www-form-urlencoded') : 'application/x-www-form-urlencoded'
  const default_config = {
    method: 'post',
    url: url,
    data: contentType === 'application/x-www-form-urlencoded' ? qs.stringify(data) : data,
    ...config
  };
  return service(default_config);
};

export default {
  get,
  post,
  service
};
